import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'emotion-theming';

import CirclePercentage from '../charts/CirclePercentage';
import HeatStreakText from './HeatStreakText';

const getGraphColor =
  ({ colors, graphVariant }) =>
  (position) =>
    colors.heatStreak[graphVariant][position];

const HeatStreakGraph = ({
  text,
  size,
  secondaryText,
  variant,
  graphVariant,
  showIcon,
  primaryTextOrder,
  secondaryTextOrder,
  assetSrc,
  isFrench,
  ...props
}) => {
  const { colors } = useTheme();
  const getColor = getGraphColor({ colors, graphVariant });

  return (
    <CirclePercentage startColor={getColor('start')} endColor={getColor('end')} size={size} {...props}>
      <HeatStreakText
        size={size}
        primaryTextOrder={primaryTextOrder}
        secondaryTextOrder={secondaryTextOrder}
        iconColor={getColor('start')}
        text={text}
        secondaryText={secondaryText}
        showIcon={showIcon}
        variant={variant}
        assetSrc={assetSrc}
        isFrench={isFrench}
      />
    </CirclePercentage>
  );
};

HeatStreakGraph.propTypes = {
  primaryTextOrder: PropTypes.number,
  secondaryTextOrder: PropTypes.number,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.string,
  secondaryText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  graphVariant: PropTypes.string,
  variant: PropTypes.string,
  assetSrc: PropTypes.string,
  showIcon: PropTypes.bool,
  isFrench: PropTypes.bool,
};

export default HeatStreakGraph;
